<template lang="pug">
tr.app-result
	td.app-result__cell
		a.app-result__download(v-if="result.url" :target="config.openInNewWindow ? '_blank' : '_self'" title="Download resource" :href="result.url" :download="result.url")
			i.blue-icon-download-bottom
	td.app-result__cell
		component.app-result__title(
			:is="result.url ? 'a' : 'span'"
			:href="result.url"
			:target="config.openInNewWindow ? '_blank' : '_self'"
			:title="result.title"
		) {{result.title}}
	td.app-result__cell.app-result__cell--caps.app-result__cell--pipe
		span(v-if="result.meta.resource_type") {{ displayType }}
		span(v-if="result.meta.resource_size") {{ displaySize }}
	td.app-result__cell
		time.app-result__date(:datetime="result.itemDate || ''") {{ !!result.itemDate ? displayDate : '' }}
</template>
	
<script>
	import { format } from "date-fns";
	import { mapGetters } from "vuex";

	export default {
		name: "AppResult",
		props: {
			result: Object,
			index: Number,
			results: Array,
		},
		components: {},
		data() {
			return {};
		},
		computed: {
			...mapGetters([
				"siteName"
			]),
			displayDate() {
				return format(new Date(this.result.itemDate), "MMM d, yyyy");
			},
			displaySize() {
				if (!!this.result.meta.resource_size && this.result.meta.resource_size.split(" ").length > 0) {
					return this.result.meta.resource_size.split(" ").join("");
				} else return this.result.meta.resource_size;
			},
			displayType() {
				let type = this.result.meta.resource_type;
				type = type.split("/")[type.split("/").length - 1];
				let alphaRegex = /^[a-zA-Z0-9]+$/g;
				if (!type.match(alphaRegex)) {
					let pathArray = this.result.url.split("/").filter(p => !!p);
					let file = pathArray[pathArray.length - 1];
					let fileType = file.split(".")[file.split(".").length - 1];
					return fileType;
				}
				return type;
			},
		},
	};
</script>

<style lang="scss" scoped>
#bluesearch {
	.app-result {
		&__cell {
			border: none;
			font-size: 0.875rem;
			max-width: 600px;
			&--center {
				text-align: center;
				justify-content: center;
			}
			&--pipe {
				display: flex;
				gap: 0.5rem;
				span {
					&:not(:last-child) {
						&::after {
							content: "|";
							margin-left: 0.5rem;
						}
					}
				}
			}
			&--caps {
				text-transform: uppercase;
			}
		}
		&__download {
			@include clean(button);
			display: flex;
			justify-content: center;
			align-items: center;
			margin: 0 auto;
			vertical-align: middle;
			i {
				color: $darkGray;
				font-size: 1.375rem;
				line-height: 1.25;
				transition: inherit;
				font-weight: 700;
				.page--ORG & {
					color: $lightBlackOrg;
				}
			}
			&:hover {
				i {
					.page--ORG & {
						color: $brightBlueAltOrg;
					}
				}
			}
		}
		&__title {
			font-weight: 600;
			@include fluid(font-size, 1rem, 1.1875rem);
			line-height: 1.421;
			display: block;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			&:is(a) {
				text-decoration: none;
				&:hover {
					text-decoration: underline;
				}
			}
		}

		@include mqdn(lg_dn) {
			display: flex;
			flex-direction: column;
			&__cell {
				max-width: 100%;
				width: 100%;
				text-align: left;
				justify-content: flex-start;
				&:first-child {
					display: none;
				}
				&:not(:last-child) {
					padding-bottom: 0;
				}
			}
			&__title {
				max-width: 100%;
				white-space: normal;
			}
		}
	}
	table tbody .app-result:nth-child(2n) {
		background: $white;
	}
	table tbody .app-result:nth-child(2n - 1) {
		background: rgba($lightGray, 0.5);
		.page--ORG & {
			background: rgba($lightGrayOrg, 0.25);
			@include mqdn(lg_dn) {
				background: rgba($lightGrayOrg, 0.5);
			}
		}
	}
}
</style>